import PropTypes from "prop-types";
import Helmet from "react-helmet";

const url = window.location.href;

const SeoComponent = ({ title, local, description, image }) => {
  return (
    <Helmet>
      <title>{title}</title>

      {description && <meta name="description" content={description} />}
      {image && <meta name="image" content={image} />}

      <link
        rel="alternate"
        href={url.replace(`/${local}/`, "/en/")}
        hreflang="en"
      />
      <link
        rel="alternate"
        href={url.replace(`/${local}/`, "/es/")}
        hreflang="es"
      />
      <link
        rel="alternate"
        href={url.replace(`/${local}/`, "/ar/")}
        hreflang="ar"
      />
      <link
        rel="alternate"
        href={url.replace(`/${local}/`, "/fr/")}
        hreflang="fr"
      />

      <meta property="og:url" content={url} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}
    </Helmet>
  );
};

SeoComponent.propTypes = {
  title: PropTypes.string.isRequired,
  local: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
};

export default SeoComponent;
